/*
 * Import Button Messages
 *
 * This contains all the text for the Import Button.
 */

import { defineMessages } from 'react-intl';
const scope = 'src.pages.TimeTrackingPage.components.ImportButton';

export default defineMessages({
  importButton: {
    id: `${scope}.importButton`,
    defaultMessage: 'Import',
  },
  importConfirmMessage: {
    id: `${scope}.importConfirmMessage`,
    defaultMessage:
      'Are you sure you want to import these Time Tracking records?',
  },
});
